import styled from "styled-components";
import { Tabs } from "react-bootstrap";

export const SingleSimSection = styled.section`
  & ul.nav-tabs {
    border: 0;
    @media screen and (max-width: 576px) {
      justify-content: center;
    }
  }
`;
export const StyledTabs = styled(Tabs)`
  @media screen and (max-width: 576px) {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
  }
  & button.sim-tab {
    display: grid;
    grid-template-columns: 1fr 0fr;
    grid-column-gap: 2px;
    justify-content: center;
    align-items: center;
    font-weight: 500;
    background-color: var(--deactive-color);
    margin-left: 10px;
    border-radius: 12px 12px 0 0;
    &.active {
      color: var(--white-color) !important;
      background-color: var(--primary-color) !important;
    }
    &.disabled {
      color: var(--white-color) !important;
      background-color: var(--deactive-color);
    }
    .tab-icon {
      width: 26px;
      height: 26px;
    }
    @media screen and (max-width: 576px) {
      width: 65px;
      font-size: 10px;
      margin-left: 5px;
      .tab-icon {
        width: 19px;
        height: 19px;
      }
    }
    @media screen and (max-width: 320px) {
      width: 52px;
    }
  }
`;

export const TabContentSection = styled.section`
  background: var(--button-color-labs);
  border-radius: 12px 0px 12px 12px;
  border-radius: ${({ $info }) => ($info ? "12px 0px 12px 12px" : "12px")};
  color: var(--text-color-dark);
  & .title {
    font-weight: 500;
    font-size: var(--font-size-lg);
    @media screen and (max-width: 576px) {
      font-size: var(--font-size-base);
    }
  }
`;
